import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@vaadin/accordion/theme/material/vaadin-accordion.js';
import { elements } from './sdb-elements.js';
/**
 * Accordion element, used to 'wrap' accordionitem elements
 *
 * @slot - This is an unnamed slot (default slot)
 *
 * @prop {Boolean} colored - If used, opened accordion items will have a blue background (default false)
 * @prop {Boolean} separator - If used, the accordion items will be visually seperated with a thin line
 * @prop {Boolean} noPadding - Used to display the accordion correctly inside other elements (e.g. collapsablecard)
 * @prop {String} centerIcons - optional, used to center icons if displayed in the accordionitems
 * @prop {String} contentTop - optional, used to display all text content in top of accordionitem (instead of center)
 * @prop {String} minHeight - optional, used to set a specific min-height for all acordionitems in accordion
 *
 */
let SDBContentAccordion = class SDBContentAccordion extends LitElement {
    constructor() {
        super(...arguments);
        this.colored = false;
        this.noPadding = false;
        this.contentTop = false;
        this.minHeight = 'auto';
    }
    render() {
        return html ` <vaadin-accordion><slot></slot></vaadin-accordion> `;
    }
    firstUpdated() {
        this.style.setProperty('--sdb-accordionitem-min-height', this.minHeight);
    }
};
SDBContentAccordion.styles = [
    elements,
    css `
            :host {
                display: block;
                position: relative;
                padding: 0;
                width: 100%;

                /* OVERRULE MATERIAL DESIGN SHADOW */
                --material-shadow-elevation-2dp: none;
                --material-shadow-elevation-3dp: none;
                --material-shadow-elevation-4dp: none;
                --material-shadow-elevation-6dp: none;
                --material-shadow-elevation-8dp: none;
                --material-shadow-elevation-12dp: none;
                --material-shadow-elevation-16dp: none;
                --material-shadow-elevation-24dp: none;

                --sdb-accordion-colored-background-opened: var(
                    --theme-tertiary
                );
                --sdb-accordion-colored-foreground-opened: var(--text-light);
                --sdb-accordion-colored-toggle-opened: #ffffff;
            }

            :host vaadin-accordion {
                display: block;
                width: 100%;
            }

            :host([colored]) {
                --sdb-accordion-background-opened: var(
                    --sdb-accordion-colored-background-opened
                );
                --sdb-accordion-foreground-opened: var(
                    --sdb-accordion-colored-foreground-opened
                );
                --sdb-accordion-toggle-opened: var(
                    --sdb-accordion-colored-toggle-opened
                );
            }

            :host * {
                font-family: 'Source Sans Pro', sans-serif !important;
                font-size: 16px;
            }

            :host([separator]) {
                --sdb-accordion-separator: var(--separator-color);
            }

            :host
                ::sdb-content-accordionitem:first-of-type
                > ::vaadin-accordion-panel {
                padding-top: 10px;
            }

            /* Set padding for items and heading */

            :host {
                --sdb-accordionheading-after-left: 20px;
                --sdb-accordionheading-after-width: 40px;
                --sdb-accordionheading-padding-left: 30px;
                --sdb-accordionheading-padding-right: 70px;
                --sdb-accordionitem-before-after-height: 10px;
                --sdb-accordionitem-vaadin-accordion-panel-padding: 20px;
                --sdb-accordionitem-summary-padding: 10px;
                --sdb-accordionitem-summary-vertical-padding: 15px;
                --sdb-accordionitem-icon-justify: start;
                --sdb-accordionitem-icon-align: start;
                --sdb-accordionitem-icon-padding-left: 10px;
                --sdb-accordionitem-main-justify: center;
                --sdb-accordionitem-main-align: center;
                --sdb-accordionitem-min-height: auto;
            }

            :host([noPadding]) {
                /*removed compensation to match padding of vaadin-accordion-panel */
                --sdb-accordionheading-after-left: 0;
                --sdb-accordionheading-after-width: 0;
                --sdb-accordionheading-padding-left: 0;
                --sdb-accordionheading-padding-right: 50px;
                --sdb-accordionitem-before-after-height: 0;
                --sdb-accordionitem-vaadin-accordion-panel-padding: 0;
                --sdb-accordionitem-summary-padding: 0;
                --sdb-accordionitem-summary-vertical-padding: 0;
            }

            :host([centerIcons]) {
                --sdb-accordionitem-icon-justify: center;
                --sdb-accordionitem-icon-align: center;
                --sdb-accordionitem-icon-padding-left: 0;
            }

            :host([contentTop]) {
                --sdb-accordionitem-content-align: start;
                --sdb-accordionitem-main-justify: start;
                --sdb-accordionitem-main-align: start;
            }
        `,
];
__decorate([
    property({ type: Boolean })
], SDBContentAccordion.prototype, "colored", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentAccordion.prototype, "noPadding", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentAccordion.prototype, "contentTop", void 0);
__decorate([
    property({ type: String })
], SDBContentAccordion.prototype, "minHeight", void 0);
SDBContentAccordion = __decorate([
    customElement('sdb-content-accordion')
], SDBContentAccordion);
export { SDBContentAccordion };
//# sourceMappingURL=sdb-content-accordion.js.map